import { Input } from "antd";
import styled from "styled-components";

import React from "react";
import { theme } from "../../../theme";

interface TextAreaProps {
  autoSize?: boolean | object;
  placeholder?: string;
  height?: number;
  value?: string;
  disabled?: boolean;
  onChange: (e: string) => void;
}

const TextAreas: React.FC<TextAreaProps> = ({
  height,
  value,
  disabled,
  onChange,
  autoSize,
  placeholder,
}) => {
  return (
    <TextareaWrapper height={height}>
      <Areas
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        autoSize={autoSize}
        value={value}
      />
    </TextareaWrapper>
  );
};

export const Areas = styled(Input.TextArea)`
  flex: 1 1 0;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #d2d2d2;
  :disabled {
    background: #fff;
    color: black;
  }
  transition: all 0.3s;
  ::placeholder {
    color: ${theme.colors.gray3};
  }
  resize: none;
`;
const TextareaWrapper = styled.div<{ height?: number }>`
  max-height: ${({ height }) => `${height}px` || "120px"};
  height: 100vh;
  width: 100%;
  display: flex;
`;
export default TextAreas;
